import React from "react";
import PropTypes from "prop-types";

import DialogTitle from "ui/DialogTitle";

import Content from "./Content";

import DialogActions from "components/DialogActions";

const TypeSelector = ({ orgHasCalendar, onSelect, onClose }) => {
  return (
    <>
      <DialogTitle title={"Select Block Type"} onClose={onClose} />
      <Content orgHasCalendar={orgHasCalendar} onSelect={onSelect} />
      <DialogActions onCancel={onClose} />
    </>
  );
};

TypeSelector.propTypes = {
  orgHasCalendar: PropTypes.bool.isRequired,
  onSelect: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default TypeSelector;
